import React from 'react'
import Heromainsec from './Heromainsec'
import Heroslider from './Heroslider'

const Herosection = () => {
  return (
    <div className="hero-section-container">
        <Heromainsec/>
        <Heroslider/>
    </div>
  )
}

export default Herosection